import useAppLanguage from "@/components/Root/hooks/useAppLanguage";
import useApplyPromoCodeFromParam from "@/components/Root/hooks/useApplyPromoCodeFromParam";
import useAuthTokenCheck from "@/components/Root/hooks/useAuthTokenCheck";
import useCountryCode from "@/components/Root/hooks/useCountryCode";
import usePricingDisplayData from "@/components/Root/hooks/usePricingDisplayData";
import useRouteHandle from "@/components/Root/hooks/useRouteHandle";
import UILoader from "@/components/ui/Loader";
import useControlIntercom from "@/hooks/useHideIntercom";
import { Outlet } from "@/lib/router";
import { usePageTracking } from "@/tracking/usePageTracking";
import { useSigninCheck } from "reactfire";

const SharedLayout = () => {
  const { status } = useSigninCheck();
  const { hideIntercom } = useRouteHandle();

  useControlIntercom(hideIntercom === true);
  usePageTracking();
  useCountryCode();
  useAppLanguage();
  usePricingDisplayData();
  useApplyPromoCodeFromParam();
  // useV1Redirect();
  const { checkingToken } = useAuthTokenCheck();

  if (status === "loading" || checkingToken) {
    return <UILoader />;
  }

  return <Outlet />;
};

export default SharedLayout;
